module.exports = __webpack_public_path__ + "img/logoTextZain.653ee489.svg";